export default __webpack_public_path__ + "static/media/DSA.0c14cfb3.png";